import { FileDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/files/v1/file_events_pb';
import { Col, humanReadableDateTime } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

type FileDeletedDetailProps = {
  event: FileDeletedEvent;
};

const formatFileSize = (size: bigint): string => {
  const bytes = Number(size);
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const FileDeletedDetail = ({ event }: FileDeletedDetailProps) => {
  const file = event.file;
  const deletedAtStr = protoTimestampToZonedDateTimeString(event.deletedAt);

  if (!file) {
    return (
      <Col className="@FileDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@FileDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted File
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={file.id?.value} />
          <FieldDisplay label="File Name" value={file.fileName} />
          <FieldDisplay
            label="File Size"
            value={formatFileSize(file.fileSize)}
          />
          <FieldDisplay label="MIME Type" value={file.mimeType} />
          <FieldDisplay label="Status" value={file.status} />
          <FieldDisplay label="File Type" value={file.fileType} />
          <FieldDisplay label="Deleted By" value={event.deletedBy} />
          <FieldDisplay label="Reason" value={event.reason} />
          {deletedAtStr && (
            <FieldDisplay
              label="Deleted At"
              value={humanReadableDateTime(deletedAtStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
